/**
 * Short German date formatting — "15. September" (day + month, no
 * year). Originally lived as a private helper in
 * `pwa/src/hooks/useEntitlement.ts`; extracted to a shared lib
 * module 2026-09-15 (Sebastian ruling — Meine Bücher card second
 * line) so a second call site can reuse the exact same format
 * instead of introducing a new one.
 */
export function formatGermanShortDate(iso: string): string {
  return new Intl.DateTimeFormat('de-DE', { day: 'numeric', month: 'long' }).format(new Date(iso));
}
